import type { REWARDS_EARNING_RULE_TYPE } from "./types";

export const REWARDS_EARNING_RULE_TYPES = {
    createAccount: "create_account",
    placeOrder: "place_order",
    leaveReview: "leave_review",
    newsletterSubscribe: "newsletter_subscribe",
    birthdayGift: "birthday_gift",
    instagramFollow: "instagram_follow",
    facebookPageVisit: "facebook_page_visit",
    facebookShare: "facebook_share",
    twitterFollow: "twitter_follow",
    twitterShare: "share_to_twitter",
    punchCard: "punch_card",
    goalSpend: "goal_spend",
    socialShare: "social_share",
    buyXToGetY: "buy_product_x",
    customAction: "custom_action",
    followOnTikTok: "follow_on_tiktok",
    followOnYouTube: "follow_on_youtube",
    followOnCustom: "follow_on_custom",
} as const;

export const REWARDS_BUY_X_TO_GET_Y_OBJECT_TYPES = {
    collection: "collection",
    product: "product",
} as const;

export const REWARDS_EARNING_RULE_BUTTONS_LABELS: Record<
    REWARDS_EARNING_RULE_TYPE,
    string
> = {
    [REWARDS_EARNING_RULE_TYPES.createAccount]:
        "create_account_earning_rule_button",
    [REWARDS_EARNING_RULE_TYPES.placeOrder]: "place_order_earning_rule_button",
    [REWARDS_EARNING_RULE_TYPES.leaveReview]:
        "leave_review_earning_rule_button",
    [REWARDS_EARNING_RULE_TYPES.newsletterSubscribe]:
        "newsletter_subscription_earning_rule_button",
    [REWARDS_EARNING_RULE_TYPES.birthdayGift]: "birthday_earning_rule_button",
    [REWARDS_EARNING_RULE_TYPES.instagramFollow]:
        "follow_instagram_earning_rule_button",
    [REWARDS_EARNING_RULE_TYPES.facebookPageVisit]:
        "facebook_visit_rule_button",
    [REWARDS_EARNING_RULE_TYPES.facebookShare]: "facebook_share_rule_button",
    [REWARDS_EARNING_RULE_TYPES.twitterFollow]:
        "twitter_follow_earning_rule_button",
    [REWARDS_EARNING_RULE_TYPES.twitterShare]:
        "twitter_share_earning_rule_button",
    [REWARDS_EARNING_RULE_TYPES.punchCard]: "punch_card_rule_button",
    [REWARDS_EARNING_RULE_TYPES.goalSpend]: "goal_spend_rule_button",
    [REWARDS_EARNING_RULE_TYPES.socialShare]: "social_share_rule_button",
    [REWARDS_EARNING_RULE_TYPES.buyXToGetY]: "buy_x_to_get_y_rule_button",
    [REWARDS_EARNING_RULE_TYPES.customAction]: "",
    [REWARDS_EARNING_RULE_TYPES.followOnTikTok]: "follow_on_tiktok_rule_button",
    [REWARDS_EARNING_RULE_TYPES.followOnYouTube]:
        "follow_on_youtube_rule_button",
    [REWARDS_EARNING_RULE_TYPES.followOnCustom]: "follow_on_custom_rule_button",
} as const;
